import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo, useState, useEffect, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import RowMenu from '../RowMenu/RowMenu.js';
import '../RowMenu/RowContextMenu.js';
import MultilineInput from '../../../MultilineInput/MultilineInput.js';
import Notification from '../../../Notification/Notification.js';

const PanelMenu = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl, theme }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    display: flex;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    background-color: ${theme.palette.N30.main};
    &:hover {
      background-color: ${theme.palette.N20.main};
    }
 `}
`;
const Root = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: ${theme.spacing(5, 3, 5, 5)};
    border-bottom: none;
 `}
`;
const TitleContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl, theme }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    display: flex;
    align-items: flex-start;
    
    > svg {
      min-width: 18px;
      margin: ${theme.spacing(1, 0)};
    }
 `}
`;
const MultilineInputContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl, theme }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    padding: ${theme.spacing(0, 3, 0, 3)};
    margin-top: -6px;
 `}
`;
const _Notification = styled(Notification, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl, theme }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    margin: ${theme.spacing(1, 0, 1, 4)};
 `}
`;
const PanelHeader = ({ headerText, getRowMenu, onHeaderChange, headerChangeResult, getRow, HeaderIcon, rtl, }) => {
    const row = useMemo(() => getRow(), [getRow]);
    const [inputValue, setInputValue] = useState(headerText);
    const [active, setActive] = useState(false);
    useEffect(() => {
        setInputValue(headerText);
    }, [headerText]);
    const onFocus = useCallback(() => {
        setActive(true);
    }, []);
    const onBlur = useCallback(() => {
        setActive(false);
        if (inputValue !== headerText) {
            onHeaderChange && inputValue && onHeaderChange(inputValue);
        }
    }, [inputValue, onHeaderChange, headerText]);
    const onChange = useCallback((e) => {
        setInputValue(e.target.value);
    }, []);
    useEffect(() => {
        if (headerChangeResult === null || headerChangeResult === void 0 ? void 0 : headerChangeResult.error) {
            setInputValue(headerText);
        }
    }, [headerChangeResult, headerText]);
    return (jsxs(Fragment, { children: [jsxs(Root, { children: [jsxs(TitleContainer, Object.assign({ rtl: rtl }, { children: [HeaderIcon && jsx(HeaderIcon, {}), jsx(MultilineInputContainer, Object.assign({ rtl: rtl }, { children: jsx(MultilineInput, { value: inputValue, type: "text", multiline: true, size: "large", maxRows: 2, inactive: !active, onFocus: onFocus, onBlur: onBlur, onChange: onChange }) }))] })), getRowMenu && row && (jsx(PanelMenu, Object.assign({ rtl: rtl }, { children: jsx(RowMenu, { row: row, getRowMenu: getRowMenu, panel: true, rtl: rtl }) })))] }), (headerChangeResult === null || headerChangeResult === void 0 ? void 0 : headerChangeResult.error) && (jsx(_Notification, Object.assign({ type: "error", rtl: rtl }, { children: headerChangeResult === null || headerChangeResult === void 0 ? void 0 : headerChangeResult.error.message })))] }));
};

export { PanelHeader as default };
//# sourceMappingURL=PanelHeader.js.map
